import PatientProfile from './PatientProfile';

import './index.css';

export default PatientProfile;
